/* eslint no-label-var: "off" */
import React, { useState, useEffect } from 'react';
/** Components */
import AppRouter from '../../router';

/**
 * High order components (HOC)
 */
import withoutSidenavReverse from '../../hocs/withoutSidenavReverse.hoc';

/** import elements from library Antd Framework */
import { Spin } from 'antd';

/** import icons from antd framework */
import { LoadingOutlined } from '@ant-design/icons';
import { useCheckUserAndLocation } from '../../hooks/useCheckUserAndLocation';

export default function LayoutAuthReverse(props) {
  useCheckUserAndLocation();
  const [FinishPage, setFinishPage] = useState(
    <Spin className="loader-layout-style" indicator={<LoadingOutlined />} />
  );
  useEffect(() => {
    const Final = withoutSidenavReverse({ ...props })(AppRouter);
    setFinishPage(<Final />);
  }, []);
  return <div>{FinishPage}</div>;
}
